import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authenticateWithWaToken } from "../services/api";

const ERROR_MESSAGES = {
  INVALID_TOKEN:
    "This link is no longer valid. Please log in with your mobile number and password.",
  TOKEN_USED:
    "This link is no longer valid. Please log in with your mobile number and password.",
  TOKEN_EXPIRED:
    "This link has expired. Please log in, or reply 'Hi' on WhatsApp for a new link.",
};

const FALLBACK_MESSAGE =
  "Unable to sign you in right now. Please log in with your mobile number and password.";

function WhatsAppLoginPage({ onLogin }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const attempted = useRef(false);

  useEffect(() => {
    const token = searchParams.get("t");

    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    if (attempted.current) return;
    attempted.current = true;

    (async () => {
      try {
        const response = await authenticateWithWaToken(token);

        onLogin({
          accountName: response.accountName,
          accountUniqueCode: response.accountUniqueCode,
          mobile: response.mobile,
          sessionToken: response.sessionToken,
        });

        window.history.replaceState({}, "", "/auth/wa");
        navigate("/dashboard", { replace: true });
      } catch (err) {
        setError(ERROR_MESSAGES[err.code] || FALLBACK_MESSAGE);
      }
    })();
  }, [searchParams, navigate, onLogin]);

  if (error) {
    return (
      <div style={{ padding: "24px", textAlign: "center" }}>
        <p>{error}</p>
        <a href="/login">Go to login</a>
      </div>
    );
  }

  return (
    <div style={{ padding: "24px", textAlign: "center" }}>
      <p>Signing you in…</p>
    </div>
  );
}

export default WhatsAppLoginPage;
